<template>
  <div class="card-go-to-block big-card-block block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-if-else-icon white--text text-lg-2" />
            </div>

            <h4>
              If Else Go To
              <v-icon
                v-if="errorsCount && errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <form-validation v-model="errorsCount">
          <div class="" v-if="validData">
            <div class="go-to">
              <draggable
                v-model="data.cards"
                group="cards-go-to-block"
                handle=".handle-go-to-block"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  v-for="(item, index) in data.cards"
                  :key="index"
                  class="card-go-to-item card-inner-wrapper"
                >
                  <p class="text-bold">If This Case Is True</p>
                  <filters :filters="item.filter" />
                  <v-layout row class="pa-0" justify-end>
                    <v-flex xs6>
                      <p class="mb-0">Do The Following</p>
                      <label for="">Redirect To block</label>
                    </v-flex>
                    <v-flex xs6 class="text-xs-right">
                      <v-switch
                        v-model="item.random"
                        label="Random"
                        class="pull-right"
                      />
                    </v-flex>
                  </v-layout>

                  <block-redirect
                    :blocks="item.blocks"
                    :block-list="blocksList"
                    :random="item.random"
                  />
                  <div class="inner-block-actions">
                    <v-btn
                      fab
                      small
                      color=""
                      class=""
                      @click="deleteCard(index)"
                      ><v-icon color="red">delete_outline</v-icon></v-btn
                    >
                    <v-btn class="handle-go-to-block" fab small color=""
                      ><v-icon color="#666">height</v-icon></v-btn
                    >
                  </div>
                </div>
              </draggable>
              <div class="text-xs-center">
                <v-btn
                  large
                  flat
                  class="primary--text text-bold"
                  color="white"
                  @click="addCard"
                >
                  <v-icon>add_circle</v-icon>
                  Add New Else
                </v-btn>
              </div>
            </div>
          </div>
        </form-validation>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from "../../../../utils/common";
import filters from "./common-inner-blocks/filters";
import blockRedirect from "./common-inner-blocks/block-redirect";
import draggable from "vuedraggable";
import FormValidation from "../FormValidation";
export default {
  name: "CardImageUrl",
  components: {
    filters,
    blockRedirect,
    draggable,
    FormValidation,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      valid: true,
      panel: 1,
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      common,
    };
  },
  computed: {
    variables() {
      return this.$store.state.blocksBuild.variables;
    },
  },
  watch: {
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {
    addCard() {
      this.data.cards.push({
        filter: [
          {
            attribute: "",
            operator: "is",
            value: "",
            condition: "or",
          },
        ],
        blocks: [
          {
            blocks: [],
          },
        ],
        random: false,
      });
    },
    deleteCard(index) {
      this.data.cards.splice(index, 1);
    },
  },
};
</script>

<style scoped></style>
